module.exports = __webpack_public_path__ + "img/team_02.de8ac84f.png";